import {
  getFirestore,
  onSnapshot,
  doc,
  where,
  query,
  getDoc,
  getDocs,
  updateDoc,
  collection,
  serverTimestamp,
  setDoc,
} from "firebase/firestore";
import { getAuth } from "firebase/auth";
import lodash from "lodash";
import moment from "moment";
import { TYPES } from "./income.type";
import { REF } from "../ref";
import { app } from "../../config/config";

const firestore = getFirestore(app);
const auth = getAuth(app);

// -------------- add Staff  ------------- //
export const addIncomeByStaff =
  ({ data }, callback) =>
  (dispatch) => {
    const cRef = collection(firestore, REF.INCOME_STAFF);
    //check data
    const date = data?.date;
    const branch = data?.branch;
    const c0 = where("date", "==", date);
    const c1 = where("branch", "==", branch);
    const qRef = query(cRef, c0, c1);
    getDocs(qRef).then((snapshot) => {
      if (snapshot) {
        const dataIncome = snapshot.docs.map((doc) => doc.data());
        // có data
        if (dataIncome?.length > 0) {
          const detail = dataIncome[0];
          const id = detail?.id;
          const dRef = doc(cRef, id);
          const staffs = data?.staffs || [];
          let update = {
            ...detail,
            staffs,
            updateAt: serverTimestamp(),
          };
          updateDoc(dRef, update)
            .then(() => {
              if (callback) {
                callback({
                  status: 200,
                });
              }
            })
            .catch((err) => {
              if (callback) {
                callback({
                  status: 500,
                  data: err?.message || "Please try again!",
                });
              }
            });
        } else {
          const id = doc(cRef).id;
          const dRef = doc(cRef, id);
          let onDate = data?.date || null;
          onDate = onDate && moment(onDate, "DD/MM/YYYY")?.toDate();
          let created = {
            ...data,
            id,
            onDate,
            createAt: serverTimestamp(),
          };

          // console.log({ created });

          setDoc(dRef, created, { merge: true })
            .then(() => {
              if (callback) {
                callback({
                  status: 200,
                });
              }
            })
            .catch((err) => {
              if (callback) {
                callback({
                  status: 500,
                  data: err?.message || "Please try again!",
                });
              }
            });
        }
      }
    });
  };

// -------------- snap income list  ------------- //
let incomeSub = [];
export const snapIncome =
  ({ date, branch }, callback) =>
  (dispatch) => {
    selectIncomeSuccess(dispatch, null);
    const cRef = collection(firestore, REF.INCOME_STAFF);
    const c0 = where("date", "==", date);
    const c1 = where("branch", "==", branch);
    const qRef = query(cRef, c0, c1);
    const unsub = onSnapshot(qRef, (snapshot) => {
      if (snapshot) {
        const data = snapshot.docs.map((doc) => doc.data());
        if (data?.length > 0) {
          let result = data[0];
          selectIncomeSuccess(dispatch, result);
          if (callback) {
            callback(result);
          }
        } else {
          if (callback) {
            callback(false);
          }
        }
      }
    });

    incomeSub.push(unsub);
  };

export const unSnapIncome = () => (dispatch) => {
  incomeSub?.forEach((subscriber) => {
    subscriber();
  });

  incomeSub.length = 0;
};

// -------------- dispatch  ------------- //
const selectIncomeSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SELECT_ALL_INCOME_SUCCESS,
    payload: data,
  });
};

// -------------- snap income list  ------------- //
let incomeStaffSub = [];
export const snapIncomeStaffByDate =
  ({ date, branch }, callback) =>
  (dispatch) => {
    selectIncomeByStaffSuccess(dispatch, null);
    const cRef = collection(firestore, REF.TIME_TRACKING);
    const c0 = where("date", "==", date);
    const c1 = where("branch", "==", branch);
    const qRef = query(cRef, c0, c1);
    let unsub = onSnapshot(qRef, (snapshot) => {
      if (snapshot) {
        const data = snapshot.docs.map((doc) => doc.data());
        // const converted = data?.map((item) => item?.user);
        // const unique = lodash?.uniq(converted) || null;
        selectIncomeByStaffSuccess(dispatch, data);
        if (callback) {
          callback();
        }
      }
    });

    incomeStaffSub.push(unsub);
  };

export const unSnapIncomeStaff = () => (dispatch) => {
  incomeStaffSub.forEach((subscriber) => {
    subscriber();
  });

  incomeStaffSub.length = 0;
};

// -------------- dispatch  ------------- //
const selectIncomeByStaffSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SELECT_ALL_SUCCESS,
    payload: data,
  });
};
